module.exports = __webpack_public_path__ + "img/prizes-1.33249714.png";